import { useContext } from 'react'
import { Box, Paper, Grid, SvgIcon, Typography } from '@mui/material'
import { DataContext } from '../../../contexts/data/dataContext'
import { phone, email } from '../../common/iconPaths'
import custom from '../../../styles/mui/szVariables.json'
import { analyticsDomain, analyticsCta } from '../../../services/constants'
import { sendClickAnalytics } from '../../common/util/util'

export default function ContactUs() {
    const border = custom.border
    const data = useContext(DataContext)

    function handleTelClick() {
        sendClickAnalytics('/profile', {
                domain: analyticsDomain.profile,
                name: analyticsCta.contactUs,
                metadata: {},
            })   
    }
    return (
        <Paper elevation={0} 
              sx={{ 
                borderRadius: custom.corners4, 
                border, 
                width: '100%', 
                boxSizing: 'border-box' 
              }}>
          <Box m={custom.spacing.sm}>
            <Typography variant="szHeading.Bold.xSmall">
              Contact us
            </Typography>
          </Box>
          <Box m={custom.spacing.sm}>
            <Grid container direction="row" 
                justifyContent="flex-start">
                <Grid item xs={2}>
                    <SvgIcon viewBox='0 0 32 32' 
                        sx={{ fontSize: '2rem' }}> 
                        {phone} 
                    </SvgIcon>
                </Grid>
                <Grid item xs={10}>
                    <Typography component="p" 
                        variant="szBody.Regular.Medium" 
                        id="supportPhone"
                        noWrap>
                        <a href="tel:0800116655" onClick={handleTelClick}
                            style={{ textDecoration: 'none'}}>
                                {data?.contactUs?.number}
                        </a>
                    </Typography>
                    {data?.contactUs?.hoursList.map(
                        (hours: any, i: number) => (
                        <Typography key={i} id={`hours${i+1}`}
                            variant="szBody.Regular.Small" 
                            sx={{ color: 'text.tertiary' }}>
                            {hours} <br></br>
                        </Typography>
                    ))}
                </Grid>
            </Grid>
          </Box>
          <Box m={custom.spacing.sm}>
            <Grid container direction="row" 
                  justifyContent="flex-start">
                <Grid item xs={2}>
                    <SvgIcon viewBox='0 0 32 32' 
                        sx={{ fontSize: '2rem' }}> 
                        {email}
                    </SvgIcon>
                </Grid>
                <Grid item xs={10}>
                    <Typography component="p" 
                        variant="szBody.Regular.Medium" 
                        noWrap>
                        Email
                    </Typography>
                    <Typography variant="szBody.Regular.Small" 
                        sx={{ color: 'text.tertiary' }}
                        id="supportEmail">
                        {data?.contactUs?.emailAddress}
                    </Typography>
                </Grid>
            </Grid>
          </Box>
        </Paper>
    )
}

 
      